import React from 'react'
import { Tag } from 'antd'
import { AssessmentSubtitle } from '../../Style'

export const RetryNotice = ({ assessment }) => {
  if (!assessment.isIntegrityRetry) return null
  return (
    <div role="note">
      <Tag color="blue">Retry available</Tag>
      <AssessmentSubtitle>{assessment.retryReason}</AssessmentSubtitle>
      {assessment.retryValidUntil && (
        <AssessmentSubtitle>
          Complete by {new Date(assessment.retryValidUntil).toLocaleString('en-IN', {
            timeZone: 'Asia/Kolkata', dateStyle: 'medium', timeStyle: 'short',
          })} IST
        </AssessmentSubtitle>
      )}
    </div>
  )
}
